/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import { IconDeviceFloppy } from '@tabler/icons-react';
import { Button, Group, LoadingOverlay, Paper, Space } from '@mantine/core';
import { useEffect, useState } from 'react';
import { showNotification } from '@mantine/notifications';
import { Table } from 'antd';
import { EntityServiceType } from '../../../../../../../models/core/entities.type';
import { FilterData, ServiceFormSearchFilter } from './ServiceFormSearchFilter';
import { ServiceType } from '../../../../../../../models/core/services.type';
import { SessionStorageKey } from '../../../../../../../utils/constants.utils';
import servicesService from '../../../../../../../services/core/services.service';
import { buildFakeAuditObject, newGuid } from '../../../../../../../utils/helper.utils';
import { Action } from '../../../../../../../models/core/core.type';
import TableCellEllipsis from '../../../../../../../components/core/TableCellEllipsis/TableCellEllipsis';

type FormViewProps = {
  items: EntityServiceType[];
  idEntidade: number | undefined;
  callback(items: EntityServiceType[], action: string, confirmed: boolean): void;
};

export default function ServiceFormSearch(props: FormViewProps) {
  const [data, setData] = useState<ServiceType[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState<ServiceType[]>([]);

  const handleSubmit = () => {
    props.callback(
      selectedData.map((x) => {
        return {
          ...x,
          ...buildFakeAuditObject(),
          servicoDescricao: selectedData[0].descricao,
          idEntidade: props.idEntidade || -1,
          id: newGuid(),
          action: Action.Add,
        };
      }),
      'callback',
      true
    );
  };

  const clear = () => {
    sessionStorage.removeItem(SessionStorageKey.ServiceSearch);
    setData([]);
  };

  const filter = async (inputFilterData: FilterData) => {
    try {
      setLoading(true);
      const result = await servicesService.search({
        servico: inputFilterData?.servico || null,
        limit: 1000,
        offset: 0,
      });
      sessionStorage.setItem(SessionStorageKey.ServiceSearch, JSON.stringify(result));
      setData(result);
    } catch (error: any) {
      showNotification({
        title: `Entidade - ${!props.idEntidade ? 'Adicionar' : 'Editar'}`,
        message: error?.isBusinessException ? error.description : 'Não foi possível pesquisar serviços.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: ServiceType[]) => {
      setSelectedData(selectedRows);
    },
    getCheckboxProps: (record: ServiceType) => ({
      disabled: props.items.findIndex((x) => x.idServico === record.idServico) !== -1,
      name: record.idServico.toString(),
    }),
  };

  useEffect(() => {
    const cacheResult = JSON.parse(
      sessionStorage.getItem(SessionStorageKey.ServiceSearch) || '[]'
    ) as ServiceType[];

    if (cacheResult.length > 0) {
      setData(cacheResult);
    } else {
      filter({ servico: '' });
    }
  }, []);

  return (
    <div>
      <ServiceFormSearchFilter filter={filter} clear={clear} loading={loading} />
      <div style={{ position: 'relative' }}>
        <LoadingOverlay visible={loading} />
        <Paper shadow="xs" p="md" withBorder>
          <Table
            showSorterTooltip={false}
            size="small"
            dataSource={data}
            columns={[
              {
                title: 'Servico',
                key: 'servico',
                dataIndex: 'servico',
                sorter: (a: ServiceType, b: ServiceType) => a.servico.localeCompare(b.servico),
              },
              {
                title: 'Descrição',
                key: 'descricao',
                sorter: (a: ServiceType, b: ServiceType) => {
                  return (a.descricao || '').localeCompare(b.descricao || '');
                },
                render: (row: ServiceType) => (
                  <TableCellEllipsis label={row?.descricao} numberOfChars={25} toolTipWidth={300} />
                ),
              },
            ]}
            rowSelection={{ type: 'checkbox', ...rowSelection }}
            rowKey={(item: ServiceType) => item.idServico}
            pagination={{
              pageSizeOptions: [10, 25, 50],
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
            }}
          />
        </Paper>
        <Space h="xl" />
        <Group justify="right">
          <Button leftSection={<IconDeviceFloppy size={18} />} onClick={handleSubmit}>
            Salvar
          </Button>
        </Group>
      </div>
    </div>
  );
}
